<template>
  <div class="VR"  >
     <div class="bannerBox">
         <img class="bannerImg" v-if="inwidth>768" :src="banner" alt="">
         <img class="bannerImg" v-else :src="phone_pic" alt="">
     </div>
     <div class="overAllBox products-Box">
         <div class="products-Title">Download</div>
         <div class="vrList">
             <div class="vrli" v-for="(item,index) in list" :key="index" @click="tovRDetils(item.link)">
                 <img :src="item.pic" class="vrImg" alt="">
                 <div class="vrText">{{item.title}}</div>
             </div>
         </div>
        <div class="tips" v-if="myshow"></div>
          <el-pagination v-if="mobshow==false" background layout="prev,pager,next" :pager-count='pagercount'   :hide-on-single-page="pagehide" :page-size="list_row"   :current-page.sync='page' :total="totalCount" @current-change='productList_page'></el-pagination>
     </div>
  </div>
</template>
<script>
export default {
  name: "vrList",
  components: {
  
  },
  data() {
    return {
      list_row:6,
      page:1,
      totalCount:0,
      pagehide:true,
      pagercount:5,
      banner:'',
      phone_pic:'',
      keyword:'',
      list:[],
      mobshow: false,
      myshow:false,
      mystate:false,
      inwidth:window.innerWidth,
    };
  },

 
  created(){

     let inwidth=window.innerWidth
     if (inwidth <= 750) {
        this.mobshow = true
     }
     this.getBanner();
     this.vrList(1);
        
  },
   mounted(){
      let inwidth=window.innerWidth
        if(inwidth<=320){
            this.pagercount=3
        }
       
       if (this.mobshow) {
            window.addEventListener('scroll', this.onScroll)
        } 
      
   },
  methods:{
    tovRDetils(url){
        window.open(url)
    },
    productList_page(currentPage){
      this.vrList(currentPage)
    },
     //滚动触底加载
    onScroll() {
        var that = this
        if (that.mystate) {
            if (that.getScrollHeight() <= that.getWindowHeight() + that.getDocumentTop() + $('.footer').height()) {
                that.mystate = false
                if (that.totalCount > that.list.length) {
                    let page = that.page + 1
                    that.vrList(page) //请求接口的函数
                    that.myshow = false
                } else {
                    that.myshow = true
                }
            }
        }
    },
    getBanner(){
        var that = this;
      let data = {
          page:1,
          list_row:that.list_row,
      };
        that.$api.vrList(data).then(res => {
                if (res.status == 1) {
                    that.banner=res.data.banner;
                    that.phone_pic=res.data.phone_pic;
                    
                } else {
                    that.$message({
                        message: res.msg,
                        type: "warning"
                    });
                }
            });
    },
      //产品列表接口
    vrList(page) {
      var that = this;
      let data = {
          page:page,
          list_row:that.list_row,
      };
      if (that.mobshow) {
            let mylist = that.list
            that.$api.vrList(data).then(res => {
                if (res.status == 1) {
                    mylist = mylist.concat(res.data.list)
                    that.list = mylist;
                    that.totalCount=res.data.pageInfo.totalCount
                    that.myshow=false
                    that.page=page
                    that.mystate=true
                } else {
                    that.$message({
                        message: res.msg,
                        type: "warning"
                    });
                }
            });
        }else{
            that.$api.vrList(data).then(res => {
                if (res.status == 1) {
                that.list=res.data.list;
                that.totalCount=res.data.pageInfo.totalCount
                } else {
                that.$message({
                    message: res.msg,
                    type: "warning"
                });
                }
            });
        }
    },
    //文档高度
    getDocumentTop() {
        var scrollTop = 0,
            bodyScrollTop = 0,
            documentScrollTop = 0;
        if (document.body) {
            bodyScrollTop = document.body.scrollTop;
        }
        if (document.documentElement) {
            documentScrollTop = document.documentElement.scrollTop;
        }
        scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
        return scrollTop;
    },
    //可视窗口高度
    getWindowHeight() {
        var windowHeight = 0;
        if (document.compatMode == "CSS1Compat") {
            windowHeight = document.documentElement.clientHeight;
        } else {
            windowHeight = document.body.clientHeight;
        }
        return windowHeight;
    },
    //滚动条滚动高度
    getScrollHeight() {
        var scrollHeight = 0,
            bodyScrollHeight = 0,
            documentScrollHeight = 0;
        if (document.body) {
            bodyScrollHeight = document.body.scrollHeight;
        }
        if (document.documentElement) {
            documentScrollHeight = document.documentElement.scrollHeight;
        }
        scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
        return scrollHeight;
    }, 
  },
  beforeDestroy() {//清除监听
     window.removeEventListener('scroll', this.onScroll)
  },

  
  
};
</script>
<style  >

.VR .bannerBox{
     width: 100%;
     /* height: 50rem; */
 }
.VR .bannerImg{
     width: 100%;
     height: 100%;
     vertical-align: middle;
     object-fit: cover;
 }
.VR .products-Box{
     padding-top: 5rem;
     padding-bottom: 4rem;
     text-align: center;
 }
.VR .products-Title{
    font-size: 3.6rem;
    margin-bottom: 2.8rem;
    font-weight: bold;
    letter-spacing:0.2rem;
    color: #4c4c4c;
}
.vrList{
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-right: -2rem;
}
.vrli{
    width: 59rem;
    border-bottom: 1px solid #cccccc;
    margin-right: 2rem;
    margin-bottom: 5.7rem;
    cursor: pointer;
}
.vrImg{
    width: 100%;
}
.vrText{
    text-align: center;
    color: #4c4c4c;
    font-size: 1.6rem;
    padding: 3rem 0;
}
 
.VR .el-pagination{
    margin-top: 2rem;
}
.VR .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #0c131b;
    color: #ffffff;
}
.VR  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
    width: 4rem;
    height: 4rem;
    line-height: 4rem;
    font-size: 1.4rem;
    border-radius: 0;
    color: #868686;
    background-color: #ebebeb;
}
.VR  .el-pagination.is-background .el-pager li:not(.disabled):hover{
    color: #868686;
}
.VR  .el-select__caret:before{
    content: "\e78f";
    font-size: 18px;
}
.VR  .el-select .el-input__inner:focus{
    border: none;
}
.VR  .el-input__inner{
    border: none;
}
.VR   .el-input.is-focus .el-input__inner{
    outline: none;
    border: none;
    width: 16.5rem;
    color:#999999;
    font-size: 1.6rem;
}
.tips{
    width: 100%;
    text-align: center;
    padding: 2rem 0 0;
    font-size: 1.4rem;
    color:#4c4c4c;
}
/*当浏览器尺寸768px时候的代码：*/
@media screen and (min-width:767px) and (max-width: 1024px){
    .bannerBox{
        height: auto;
    }
    
}

/*当浏览器尺寸小于768px时候的代码：手机端 */ 
@media screen and (max-width:1024px){
   .vrli{
        width: 42.5rem;
   }
   
}


/*当浏览器尺寸小于768px时候的代码：手机端 */ 
@media screen and (max-width:768px){
    .bannerImg{
        height: 40rem;
    }
   .vrli{
        width: 31.5rem;
   }
   
}


/*当浏览器尺寸小于414px时候的代码：手机端 */ 
@media screen and (max-width:414px){
     
    .bannerImg{
        height: 40rem;
    }
    .vrList{
        margin-right: 0;
    }
    .vrli{
        width: 100%;
        margin-right: 0;
   }
}






</style>
